import { useMapsLibrary } from "@vis.gl/react-google-maps";
import { createContext, FC, PropsWithChildren, useEffect, useState } from "react";

interface GoogleMapsLibraryContextProps {

    geocodingService: google.maps.Geocoder | undefined

    geocodeZipcode: (zipCode: string) => Promise<google.maps.LatLngLiteral | undefined>
    
    geocodeAddress: (street: string,
        city: string,
        state: string,
        zip: string,
        country: string,
        street2?: string
    ) => Promise<google.maps.GeocoderResult | undefined>

}

export const GoogleMapsLibraryContext = createContext<GoogleMapsLibraryContextProps | undefined>(undefined);

export const GoogleMapsLibraryProvider: FC<PropsWithChildren> = ({ children }) => {

    const geocodingApiLoaded = useMapsLibrary('geocoding');

    const [geocodingService, setGeocodingService] = useState<google.maps.Geocoder>();

    const geocodeZipcode = (zipCode: string): Promise<google.maps.LatLngLiteral | undefined> => {

        return new Promise(async (resolve, reject) => {

            if (!geocodingService) {

                reject(undefined);

            } else {

                await geocodingService.geocode({ address: zipCode }, (results, status) => {

                    if (results) {

                        resolve({ lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng() });

                    } else {

                        resolve(undefined);

                    }

                }).catch(error => resolve(undefined));

            }

        });

    }

    const geocodeAddress = (street: string, city: string, state: string, zip: string, country: string, street2: string | undefined = undefined): Promise<google.maps.GeocoderResult | undefined> => {

        return new Promise(async (resolve, reject) => {

            if (!geocodingService) {

                reject(undefined);
                
            } else {

                const address = `${street2 ? `${street} ${street2},` : `${street},`} ${city}, ${state} ${zip} ${country}`;

                await geocodingService.geocode({ address: address }, (results, status) => {

                    if (results) {

                        resolve(results[0]);

                    } else {

                        resolve(undefined);

                    }

                }).catch(error => resolve(undefined));

            }

        });

    }

    /*
        Check api is loaded and populate the service into
        state
    */
    useEffect(() => {

        if (!geocodingApiLoaded) return;

        setGeocodingService(new window.google.maps.Geocoder());

    }, [geocodingApiLoaded]);

    return (
        
        <GoogleMapsLibraryContext.Provider
            value={{ geocodingService, geocodeZipcode, geocodeAddress }}>
                
            {children}

        </GoogleMapsLibraryContext.Provider>

    )

}